import axios from 'axios';
import env from './env';

// Api sin /temba/v1 incluido en los endpoints
// Utilizado para realizar peticiones con tokens personalizados (no de sesion)
const getIpClient = async () => {
  try {
    const res = await axios.get('https://api.ipify.org/?format=json');
    return res.data.ip;
  } catch (error) {
    return '';
  }
};

export const crearApi = async () => {
  const headers = {
    'X-Client-IP': await getIpClient(),
  };

  return axios.create({
    baseURL: env.API.URL,
    headers,
  });
};

const api2 = await crearApi();

export default api2;
